/** Arányok, percek és az előző időszakhoz mért változás szövege. */
export type ValtozasIrany = 'javul' | 'romlik' | 'nulla';
export interface Valtozas { szoveg: string; irany: ValtozasIrany }

export function aranySzoveg(arany: number | null): string {
  return arany === null ? '–' : `${Math.round(arany * 100)}%`;
}

/** Előjeles eltérés százalékban, legfeljebb egy tizedessel (az eladási ár a becsléshez mérve). */
export function elteresSzoveg(arany: number | null): string {
  if (arany === null) return '–';
  const szazalek = Math.round(arany * 1000) / 10;
  const szam = Math.abs(szazalek).toLocaleString('hu-HU', { maximumFractionDigits: 1 });
  return `${szazalek > 0 ? '+' : szazalek < 0 ? '−' : ''}${szam}%`;
}

export function percSzoveg(perc: number | null): string {
  if (perc === null) return '–';
  const ora = Math.floor(perc / 60);
  const marad = perc % 60;
  if (ora === 0) return `${perc} perc`;
  return marad === 0 ? `${ora} óra` : `${ora} óra ${marad} perc`;
}

const VALTOZATLAN: Valtozas = { szoveg: 'változatlan', irany: 'nulla' };

/** Arány változása százalékpontban; a növekedés a javulás. Hiányzó adatnál null. */
export function valtozasPont(most: number | null, elozo: number | null): Valtozas | null {
  if (most === null || elozo === null) return null;
  const pont = Math.round((most - elozo) * 100);
  if (pont === 0) return VALTOZATLAN;
  return pont > 0 ? { szoveg: `+${pont} pont`, irany: 'javul' } : { szoveg: `−${-pont} pont`, irany: 'romlik' };
}

/** Reakcióidő változása percben; a csökkenés a javulás. Hiányzó adatnál null. */
export function valtozasPerc(most: number | null, elozo: number | null): Valtozas | null {
  if (most === null || elozo === null) return null;
  const kulonbseg = most - elozo;
  if (kulonbseg === 0) return VALTOZATLAN;
  const db = Math.abs(kulonbseg);
  const perc = db === 1 ? '1 perccel' : `${db} perccel`;
  return kulonbseg < 0 ? { szoveg: `${perc} gyorsabb`, irany: 'javul' } : { szoveg: `${perc} lassabb`, irany: 'romlik' };
}
